import React, { useCallback, useMemo, useState } from 'react';
import { login } from 'services/auth.service';
import { Link, useHistory } from 'react-router-dom';
import LoginForm from 'components/LoginForm/LoginForm';
import { withAuthLayout } from 'layouts/AuthLayout/AuthLayout';
import getRedirectPath from 'modules/get-redirect-path/get-redirect-path';
import cleanCognitoLocalStorage from 'modules/clean-cognito-local-storage/clean-cognito-local-storage';
import { hasPermissions } from 'modules/user-has-permission/user-has-permission';
import { useAlert } from 'context/AlertProvider';

function LoginPage(props) {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const errorMessages = useMemo(
    () => ({
      GenericException: 'Error accediendo a la aplicación',
      UserNotFoundException: 'El usuario no existe',
      NotAuthorizedException: 'Usuario o contraseña incorrecta',
    }),
    [],
  );
  const alert = useAlert();

  const submitHandler = useCallback(
    async (email, password) => {
      try {
        setLoading(true);
        setError(null);
        cleanCognitoLocalStorage();
        const { signInUserSession } = await login(email, password);
        const userHasPermissions = hasPermissions(
          signInUserSession.idToken.payload.permissions,
        );
        setLoading(false);
        if (userHasPermissions) {
          history.push(getRedirectPath());
        } else {
          alert.current.error(
            'El usuario no tiene permisos para acceder a la aplicación',
          );
        }
      } catch (error) {
        console.error(error);
        setError(errorMessages[error.code || 'GenericException']);
        setLoading(false);
      }
    },
    [history, errorMessages, alert],
  );

  return (
    <>
      <h1>Iniciar sesión</h1>
      <LoginForm
        loading={loading}
        submitHandler={submitHandler}
        error={error}
      />
      <footer className="auth-layout__footer">
        <Link to="/register">Registro</Link>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <Link to="/forgot-password">Restablecer contraseña</Link>
      </footer>
    </>
  );
}

export default withAuthLayout(LoginPage);
